const colors = {
  Grey: { title: "#7B8793", borderGrey: "#EFEFEF", placeholder: "#8e8e8e" },
  Dark: { title: "#1E1623" },
  Primary: { background: "#4B2880" },
  Background: { secondary: "#FFFFFF", primary: "#FBFBFB" },
  Error: { primary: "#EC786E" },
};

export default colors;
